import { downLoad } from './api'

export function getDload (data) {
  return downLoad(
    'https://game.hotplaygames.com/browser/get-dload',
    data,
    {'Content-Type': 'application/x-www-form-urlencoded'}
  )
}

export function setdownpkg (data) {
  return downLoad(
    'https://game.hotplaygames.com/sharedown/setdownpkg',
    data,
    {'Content-Type': 'application/x-www-form-urlencoded'}
  )
}

export function getHotplay (data) {
  return downLoad(
    'https://game.hotplaygames.com/browser/get-hotplay',
    data,
    {'Content-Type': 'application/x-www-form-urlencoded'}
  ) 
}



// WEBPACK FOOTER //
// ./src/util/hotplaygames.js